/**
 * Pastoral care's place in the navigation. Under ui_uplift = next the request list is part of
 * People (docs/design/MODULE_MAPS.md: People › Care). The classic layout leaves it out of the
 * sidebar, as it always has (it's reached from search).
 */
export const CARE_PATH = "/pastoral-care";

/**
 * Someone without the People module can still reach Care under ui_uplift = next (its route only
 * needs a signed-in member; RLS decides which requests show), but the People entry is hidden
 * from them, which left Care unreachable from the sidebar. For them the People entry becomes a
 * Care entry instead, matching the Care-only menu CommunityLayout gives them. Everyone else, and
 * every other item, is unchanged.
 */
export function careEntryInPlaceOfPeople<
  T extends { href?: string; label: string; requiredModule?: string; matchPrefixes?: string[] },
>(item: T, canAccessPeople: boolean): T {
  if (item.href !== "/people" || canAccessPeople) return item;
  return { ...item, label: "Care", href: CARE_PATH, requiredModule: undefined, matchPrefixes: [CARE_PATH] };
}

/** People's sidebar entry gains /pastoral-care, so the sidebar highlights People on the list and a request. */
export function placeCareUnderPeople<T extends { href?: string; matchPrefixes?: string[] }>(items: T[]): T[] {
  return items.map((item) =>
    item.href === "/people" && item.matchPrefixes && !item.matchPrefixes.includes(CARE_PATH)
      ? { ...item, matchPrefixes: [...item.matchPrefixes, CARE_PATH] }
      : item,
  );
}
